import { useContext } from "react";
import { ControlsContext } from "./ControlsContext";
export var useControlGroup = function () {
    var context = useContext(ControlsContext);
    if (context === undefined) {
        throw new Error("useControlGroup must be used within a ControlsContextGroup.Provider");
    }
    return context;
};
